import { Routes, Route } from "react-router-dom";

import SmsIntegrationListScreen from "screens/App/CRM/SmsIntegration/SmsIntegrationListScreen";
import SmsIntegrationDetailScreen from "screens/App/CRM/SmsIntegration/SmsIntegrationDetailScreen";
import SmsIntegrationEditScreen from "screens/App/CRM/SmsIntegration/SmsIntegrationEditScreen";
import SmsIntegrationCreateScreen from "screens/App/CRM/SmsIntegration/SmsIntegrationCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const SmsIntegrationRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<SmsIntegrationListScreen />} />
      <Route path="create" element={<SmsIntegrationCreateScreen />} />
      <Route path=":id/detail" element={<SmsIntegrationDetailScreen />} />
      <Route path=":id/edit" element={<SmsIntegrationEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default SmsIntegrationRouter;